/**
 * Testimonial card component for Enterprise page
 */

interface TestimonialCardProps {
  quote: string;
  author: string;
  title: string;
  company: string;
  companyLogo?: string;
  stats?: string;
}

export function TestimonialCard({quote, author, title, company, companyLogo, stats}: TestimonialCardProps) {
  return (
    <div className="bg-white dark:bg-[#1E1E1E] border border-gray-200 dark:border-gray-700 rounded-2xl p-8 md:p-10 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
      <div className="space-y-6">
        {stats && (
          <div className="inline-block px-4 py-2 bg-orange-600/10 dark:bg-orange-500/10 text-orange-600 dark:text-orange-500 rounded-full text-sm font-semibold mb-2">
            {stats}
          </div>
        )}
        <blockquote className="text-lg md:text-xl text-gray-700 dark:text-[#CCCCCC] leading-relaxed">
          "{quote}"
        </blockquote>
        <div className="flex items-center gap-4 pt-4 border-t border-gray-200 dark:border-gray-700">
          {companyLogo ? (
            <img src={companyLogo} alt={company} className="h-12 w-auto" />
          ) : (
            <div className="h-12 w-12 bg-[#1E1E1E] dark:bg-[#1E1E1E] rounded-full flex items-center justify-center border border-gray-200 dark:border-gray-700 flex-shrink-0">
              <span className="text-sm font-semibold text-white">{company.substring(0, 2).toUpperCase()}</span>
            </div>
          )}
          <div>
            <div className="font-semibold text-lg text-gray-900 dark:text-[#CCCCCC]">{author}</div>
            <div className="text-sm text-gray-600 dark:text-[#858585]">{title} at {company}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

